'use client';

import { FC } from 'react';
import { ComponentCtaButton } from '$/(cms)/_modules/cmsService/types';
import { CallToActionButton } from '$/components/cms/components-internal/callToActionButton/CallToActionButton';

type CtaButtonsProps = {
  buttons: ComponentCtaButton[];
};

export const CtaButtonComponents: FC<CtaButtonsProps> = ({ buttons }) => (
  <>
    {buttons.map((cta, index) => {
      const key = cta.id ?? `${cta.label}-${index}`;

      return (
        <CallToActionButton key={key} className="w-full md:w-auto" cta={cta} />
      );
    })}
  </>
);
